import supervisorConstants from '../constants';

export function openLocationDialog() {
    return { type: supervisorConstants.OPEN_LOCATION_DIALOG };
}

export function closeLocationDialog() {
    return { type: supervisorConstants.CLOSE_LOCATION_DIALOG };
}

export function receiveDivisions(divisions) {
    return { type: supervisorConstants.SUPERVISOR_DATA_SUCCESS, divisions}
}

export function receiveDivisionData(data) {
    return { type: supervisorConstants.DIVISION_DATA_SUCCESS, data}
}

export function markPendingCompetenceAsComplete(competence) {
    return { type: supervisorConstants.MARK_PENDING_COMPETENCE_AS_COMPLETE, competence };
}

export function receiveLocationCompetences(competenceData) {
    return { type: supervisorConstants.LOCATION_COMPETENCE_DATA_SUCCESS, competenceData };
}